const monthLabelShort = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

export function daysDuration(startDate, endDate) {
  return Math.round(
    Math.abs(
      (startDate.getTime() - endDate.getTime()) / (24 * 60 * 60 * 1000)
    )
  ) + 1;
}

/**
 * Returns date label for a training item
 *
 * @example 12 en 13 jan | 12 t/m 14 jan | 28 feb en 1 mrt,
 * @param datum_start
 * @param datum_eind
 * @returns {string}
 */
export function getTrainingDateRangeLabel(datum_start, datum_eind) {
  // count date from UTC time in case people visit the lyceo website from other parts of the world
  const timezone = 'T00:00:00Z';
  let startDate = new Date(datum_start + timezone);
  let endDate = new Date(datum_eind + timezone);

  // set month label
  let beginMaand = monthLabelShort[startDate.getUTCMonth()];
  let eindMaand = monthLabelShort[endDate.getUTCMonth()];

  // add the month label to the start of the label if the training spans multiple months
  // for example: 28 feb en 1 mrt
  let begin = `${startDate.getUTCDate()} ${beginMaand !== eindMaand ? beginMaand + ' ' : ''}`;
  let eind = `${endDate.getUTCDate()} ${eindMaand}`;

  // set number of days
  let days = daysDuration(startDate, endDate);
  const connector = days === 2 ? 'en' : 't/m';

  return `${begin}${connector} ${eind}`;
}

/**
 * Removes the last :00 from the 09:00:00 time notation
 * also removed the leading zero -> 9:00
 * @param startTime
 * @param endTime
 */
export function getTimeLabel(startTime, endTime) {
  const start = startTime.substring(0, 5).replace(/^0+/, '');
  const end = endTime.substring(0, 5).replace(/^0+/, '');
  return `${start} - ${end}`;
}

